import { getMappedEvents } from '../utils/getMappedEvents';

export const EVENTS = [
  'uploadCustomizeTranslationClicked',
  'promptTemplateFormalClicked',
  'promptTemplateInformalClicked',
  'promptTemplateIndustrySpecificClicked',
  'promptTemplateIstClicked',
  'uploadPromptLearnMoreClicked',
  'translationWithPromptUpload',
  'retranslationWithPromptFromProject',
  'cancelPromptFromProject',
] as const;

export const userPromptingEvents = getMappedEvents([...EVENTS]);
